import { fabric } from 'fabric';
import { updateLabel } from './label';
import {
  ACTIVE_SELECTION,
  DOWN,
  eventBus,
  FABRIC_CUSTOM_OBJECT,
  generateId,
  getObjId,
  LEFT,
  LINE_SHAPE_TYPE,
  propertiesToInclude,
  RIGHT,
  UP,
} from '../utils';
import { addArrowLine } from './lineControl';
import { getIndex } from './container';
import '../fabric_obj/customObj/ArrowLineRender';

export const state4Port = Object.create({
  Port_1: false,
  Port_2: false,
  Port_3: false,
  Port_4: false,
});
let control1 = new fabric.Point(0, 0);
let control2 = new fabric.Point(0, 0);
export function distance(A, B) {
  return (A.x - B.x) * (A.x - B.x) + (A.y - B.y) * (A.y - B.y);
}
export function updateId(line) {
  if (line.fromNode && line.fromNode.id) return;
  const { canvas } = window;
  canvas.getObjects().map((polyline) => {
    if (polyline.type === FABRIC_CUSTOM_OBJECT.polyline) {
      canvas.getObjects().map((obj) => {
        if (obj.id === polyline.toId) polyline.set({ toNode: obj });
        if (obj.id === polyline.fromId) polyline.set({ fromNode: obj });
        return obj;
      });
    }
    return polyline;
  });
}
function getAllPort(o) {
  o.setCoords();
  const { tl, br } = o.aCoords;
  const { x: left, y: top } = tl;
  const { x: right, y: bot } = br;

  return {
    mt: { x: (left + right) / 2, y: top },
    mb: { x: (left + right) / 2, y: bot },
    ml: { x: left, y: (top + bot) / 2 },
    mr: { x: right, y: (top + bot) / 2 },
  };
}
export function getPort(o, str) {
  const allPort = getAllPort(o);
  return allPort[str];
}
export function getTheNearestPort(point, o) {
  const obj = o;
  let fromPort = { x: 10000, y: 10000 };
  const allPort = getAllPort(obj);
  if (distance(allPort.mt, point) < distance(fromPort, point)) fromPort = { ...allPort.mt, port: 'mt' };
  if (distance(allPort.mb, point) < distance(fromPort, point)) fromPort = { ...allPort.mb, port: 'mb' };
  if (distance(allPort.ml, point) < distance(fromPort, point)) fromPort = { ...allPort.ml, port: 'ml' };
  if (distance(allPort.mr, point) < distance(fromPort, point)) fromPort = { ...allPort.mr, port: 'mr' };
  return {
    x: fromPort.x,
    y: fromPort.y,
    fromNode: obj,
    fromPort: fromPort.port,
    id: o.id,
  };
}

export function getPathFromTwoPoints(point1, point2, fromPort, toPort) {
  const eps = 20;
  const list = [];
  const x = (point1.x + point2.x) / 2;
  const y = (point1.y + point2.y) / 2;
  const pMid = { x, y };
  let pStart;
  let pEnd;
  switch (fromPort) {
    case 'mt':
      pStart = { x: point1.x, y: point1.y - eps };
      break;
    case 'mb':
      pStart = { x: point1.x, y: point1.y + eps };
      break;
    case 'ml':
      pStart = { x: point1.x - eps, y: point1.y };
      break;
    default:
      pStart = { x: point1.x + eps, y: point1.y };
      break;
    // default: break;
  }
  switch (toPort) {
    case 'mt':
      pEnd = { x: point2.x, y: point2.y - eps };
      break;
    case 'mb':
      pEnd = { x: point2.x, y: point2.y + eps };
      break;
    case 'ml':
      pEnd = { x: point2.x - eps, y: point2.y };
      break;
    default:
      pEnd = { x: point2.x + eps, y: point2.y };
      break;
    // default: break;
  }

  const up = pStart.y >= pEnd.y;
  const down = !up;
  const left = pStart.x >= pEnd.x;
  const right = !left;

  switch (fromPort) {
    case 'mt':
      switch (toPort) {
        case 'mt':
          list.push(point1);
          list.push({ x: pStart.x, y: Math.min(pStart.y, pEnd.y) });
          list.push({ x: pEnd.x, y: Math.min(pStart.y, pEnd.y) });
          list.push(point2);
          break;
        case 'mb':
          if (down) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: Math.min(pStart.y, pEnd.y) });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        case 'ml':
          if (left) {
            if (up) {
              list.push(point1);
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
              list.push(pEnd);
              list.push(point2);
            } else {
              list.push(point1);
              list.push(pStart);
              list.push({ x: pEnd.x, y: pStart.y });
              list.push(pEnd);
              list.push(point2);
            }
          } else if (up) {
            list.push(point1);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(point2);
          }
          break;

        default:
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (up) {
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
            } else {
              list.push({ x: pEnd.x, y: pStart.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (up) {
            list.push(point1);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);

            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });

            list.push(point2);
          }
          break;
        // default: break;
      }
      break;
    case 'mb':
      switch (toPort) {
        case 'mt':
          if (down) {
            list.push(point1);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        case 'mb':
          if (up) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pEnd.x, y: pStart.y });
            list.push(point2);
          } else {
            list.push(point1);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        case 'ml':
          if (left) {
            if (up) {
              list.push(point1);
              list.push(pStart);
              list.push({ x: pEnd.x, y: pStart.y });
              list.push(pEnd);
              list.push(point2);
            } else {
              list.push(point1);
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
              list.push(pEnd);
              list.push(point2);
            }
          } else if (up) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(point2);
          }
          break;
        default:
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (up) {
              list.push({ x: pEnd.x, y: pStart.y });
            } else {
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (up) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(point2);
          }
          break;
        // default: break;
      }
      break;
    case 'ml':
      switch (toPort) {
        case 'mt':
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (up) {
              list.push({ x: pStart.x, y: pEnd.y });
            } else {
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (up) {
            list.push(point1);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push({ x: pEnd.x, y: pStart.y });
            list.push(point2);
          }
          break;
        case 'mb':
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (down) {
              list.push({ x: pStart.x, y: pEnd.y });
            } else {
              list.push({ x: pStart.x, y: pMid.y });
              list.push({ x: pEnd.x, y: pMid.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (down) {
            list.push(point1);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push({ x: pEnd.x, y: pStart.y });
            list.push(point2);
          }
          break;
        case 'ml':
          list.push(point1);
          list.push(pStart);
          list.push({ x: Math.min(pEnd.x, pStart.x), y: pStart.y });
          list.push({ x: Math.min(pEnd.x, pStart.x), y: pEnd.y });
          list.push(pEnd);
          list.push(point2);
          break;
        default:
          if (right) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        // default: break;
      }
      break;
    // case 'mr':
    default:
      switch (toPort) {
        case 'mt':
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (down) {
              list.push({ x: pEnd.x, y: pStart.y });
            } else {
              list.push({ x: pMid.x, y: pStart.y });
              list.push({ x: pMid.x, y: pEnd.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (down) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        case 'mb':
          if (right) {
            list.push(point1);
            list.push(pStart);
            if (up) {
              list.push({ x: pEnd.x, y: pStart.y });
            } else {
              list.push({ x: pMid.x, y: pStart.y });
              list.push({ x: pMid.x, y: pEnd.y });
            }
            list.push(pEnd);
            list.push(point2);
          } else if (up) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        case 'ml':
          if (!right) {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pStart.x, y: pMid.y });
            list.push({ x: pEnd.x, y: pMid.y });
            list.push(pEnd);
            list.push(point2);
          } else {
            list.push(point1);
            list.push(pStart);
            list.push({ x: pMid.x, y: pStart.y });
            list.push({ x: pMid.x, y: pEnd.y });
            list.push(pEnd);
            list.push(point2);
          }
          break;
        // case 'mr':
        default:
          list.push(point1);
          list.push(pStart);
          list.push({ x: Math.max(pEnd.x, pStart.x), y: pStart.y });
          list.push({ x: Math.max(pEnd.x, pStart.x), y: pEnd.y });
          list.push(pEnd);
          list.push(point2);
          break;
        // default: break;
      }
      break;
    // default: break;
  }
  return list;
}
export function getPath(o) {
  const line = o;
  updateId(line);
  let point1;
  let point2;
  if (line.fromNode) point1 = getPort(line.fromNode, line.fromPort);
  else point1 = { ...line.points[0] };

  if (line.toNode) point2 = getPort(line.toNode, line.toPort);
  else point2 = { ...line.destination };

  if (!line.toPort && line.fromPort) {
    switch (line.fromPort) {
      case 'mt':
        line.set({ toPort: 'mb' });
        break;
      case 'mb':
        line.set({ toPort: 'mt' });
        break;
      case 'ml':
        line.set({ toPort: 'mr' });
        break;
      default:
        line.set({ toPort: 'ml' });
        break;
    }
  } else if (!line.fromPort && line.toPort) {
    switch (line.toPort) {
      case 'mt':
        line.set({ fromPort: 'mb' });
        break;
      case 'mb':
        line.set({ fromPort: 'mt' });
        break;
      case 'ml':
        line.set({ fromPort: 'mr' });
        break;
      default:
        line.set({ fromPort: 'ml' });
        break;
    }
  }
  if (line.name && line.name.search('Line') !== -1) return [point1, point2];
  return getPathFromTwoPoints(point1, point2, line.fromPort, line.toPort);
}
export function autoFixLine(o) {
  let tmpStart;
  let tmpEnd;
  const eps = 200;
  const { canvas } = window;
  const point1 = control1;
  const point2 = control2;
  let fromPort1 = { x: 10000, y: 10000 };
  let fromPort2 = { x: 10000, y: 10000 };
  canvas.getObjects().forEach((obj) => {
    if (obj.isDiagram && obj.id !== o.fromNode.id) {
      tmpStart = getTheNearestPort(point1, obj);
      tmpEnd = getTheNearestPort(point2, obj);
      if (distance(tmpStart, point1) < distance(fromPort1, point1)) fromPort1 = { ...tmpStart };
      if (distance(tmpEnd, point2) < distance(fromPort2, point2)) fromPort2 = { ...tmpEnd };
    }
    return obj;
  });
  if (distance(point2, fromPort2) < eps) {
    control2 = { x: fromPort2.x, y: fromPort2.y };
    o.set({
      toPort: fromPort2.fromPort,
      toNode: fromPort2.fromNode,
      toId: fromPort2.fromNode.id,
    });
  } else o.set({ toNode: null, toId: null });
}
export function addArrow(list, strokeWidth) {
  const delta = strokeWidth;
  const sizeArrow = 6;
  let direction = 'right';
  const l1 = list[list.length - 1];
  const l2 = list[list.length - 2];
  let A = { x: l1.x, y: l1.y };
  const B = { x: l2.x, y: l2.y };
  if (A.x - B.x < -1) direction = 'left';
  else if (B.x - A.x < -1) direction = 'right';
  else if (A.y - B.y < -1) direction = 'up';
  else if (B.y - A.y < -1) direction = 'down';
  let p1;
  let p2;
  let p3;
  let p4;
  switch (direction) {
    case 'left':
      A = { x: A.x + delta, y: A.y };
      p1 = { x: A.x + sizeArrow * 2, y: A.y };
      p2 = { x: p1.x, y: p1.y - sizeArrow };
      p3 = A;
      p4 = { x: p1.x, y: p1.y + sizeArrow };
      break;
    case 'right':
      A = { x: A.x - delta, y: A.y };
      p1 = { x: A.x - sizeArrow * 2, y: A.y };
      p2 = { x: p1.x, y: p1.y - sizeArrow };
      p3 = A;
      p4 = { x: p1.x, y: p1.y + sizeArrow };
      break;
    case 'up':
      A = { x: A.x, y: A.y + delta };
      p1 = { x: A.x, y: A.y + sizeArrow * 2 };
      p2 = { x: p1.x - sizeArrow, y: p1.y };
      p3 = A;
      p4 = { x: p1.x + sizeArrow, y: p1.y };
      break;
    case 'down':
      A = { x: A.x, y: A.y - delta };
      p1 = { x: A.x, y: A.y - sizeArrow * 2 };
      p2 = { x: p1.x - sizeArrow, y: p1.y };
      p3 = A;
      p4 = { x: p1.x + sizeArrow, y: p1.y };
      break;
    default:
      break;
  }
  list.pop();
  const arr = [];
  list.map((e) => arr.push({ x: e.x, y: e.y }));

  list.push(p1, p2, p3, p4, p1);
  for (let i = arr.length - 1; i >= 0; i -= 1) {
    list.push({ x: arr[i].x, y: arr[i].y });
  }
}
function updateLine(obj) {
  let point;
  const o = obj;
  updateId(o);
  if (o.fromNode) {
    point = getAllPort(o.fromNode)[o.fromPort];
    o.set({ x1: point.x, y1: point.y });
  }

  if (o.toNode) {
    point = getAllPort(o.toNode)[o.toPort];
    o.set({ x2: point.x, y2: point.y });
  }
}
export function removeId(id) {
  window.canvas.getObjects().map((e) => {
    if (e.id === id && e.type === FABRIC_CUSTOM_OBJECT.polyline) window.canvas.remove(e);
    return e;
  });
}
export function updateConnector(o) {
  const line = o;
  const { canvas } = window;
  const points = getPath(line);
  const destination = { ...points[points.length - 1] };
  if (line.name === FABRIC_CUSTOM_OBJECT.arrowLine) addArrowLine(points, destination, 1);
  else if (line.name !== FABRIC_CUSTOM_OBJECT.line) addArrow(points, line.strokeWidth);
  const index = getIndex(line);
  canvas.remove(line);
  const polyline = new fabric.Polyline(points, {
    padding: 20,
    name: line.name,
    fill: line.fill,
    stroke: line.stroke,
    strokeWidth: line.strokeWidth,
    strokeDashArray: line.strokeDashArray,
    strokeLineCap: line.strokeLineCap,
    toPort: line.toPort,
    fromPort: line.fromPort,
    toNode: line.toNode,
    fromNode: line.fromNode,
    toId: line.toId,
    fromId: line.fromId,
    hasControls: line.hasControls,
    hasBorders: line.hasBorders,
    lockMovementX: line.lockMovementX,
    lockMovementY: line.lockMovementY,
    perPixelTargetFind: true,
    destination,
    objectCaching: false,
  });
  if (line.id) polyline.set({ id: line.id });
  else polyline.set({ id: generateId() });
  removeId(polyline.id);
  canvas.insertAt(polyline, index);
  updateLabel(polyline);
  canvas.requestRenderAll();
}
export function UpdateAllPathsAssociatedWithObj(o) {
  if (!o.target) return;
  const { canvas } = window;
  if (!canvas) return;
  canvas.getObjects().forEach((obj) => {
    if (obj.type === FABRIC_CUSTOM_OBJECT.polyline) {
      updateId(obj);
      if (o.target.id) {
        if (obj.toId === o.target.id) obj.set({ toNode: o.target });
        if (obj.fromId === o.target.id) obj.set({ fromNode: o.target });
      }
      if (obj.toNode === o.target || obj.fromNode === o.target) {
        updateLine(obj);
        updateConnector(obj);
      }
    }
  });
}
/* updatePathArrow...
  Currently the coordinates of the selected objects are calculated based on the border box.
  We need to get the coordinates of the objects based on the canvas -
  to calculate the coordinates of the points of the path arrow.
  So that:
  1. we will discard selected objects,
  2. get the coordinates of objects based on canvas
  3. update path arrow - calculate coordinates of the points of the path arrow.
  4. reselect objects
*/
export function updatePathArrowOfObjectsInActiveSelection(activeSelectionObject) {
  if (!activeSelectionObject?.getObjects()?.find((object) => object.isDiagram)) return;
  const listIdSelected = activeSelectionObject.getObjects().map((object) => object.id);
  window.canvas.discardActiveObject();
  const listDiagramObjectSelected = window.canvas
    .getObjects()
    .filter((object) => object.isDiagram && listIdSelected.includes(object.id));
  listDiagramObjectSelected.forEach((object) => {
    UpdateAllPathsAssociatedWithObj({ target: object });
  });
  const listObjectSelected = window.canvas.getObjects().filter((object) => listIdSelected.includes(object.id));
  const objectsSelecttion = new fabric.ActiveSelection(listObjectSelected, {
    canvas: window.canvas,
  });
  window.canvas.setActiveObject(objectsSelecttion);
  window.canvas.requestRenderAll();
}
export function getPortFromDiagramObj(target) {
  const { canvas } = window;
  const listPort = [];
  canvas.getObjects().forEach((obj) => {
    if (obj.isDiagram && obj !== target) {
      obj.setCoords();
      const { mb, mt, ml, mr } = getAllPort(obj);
      listPort.push({ x: mb.x, y: mb.y });
      listPort.push({ x: mt.x, y: mt.y });
      listPort.push({ x: ml.x, y: ml.y });
      listPort.push({ x: mr.x, y: mr.y });
    }
  });
  return listPort;
}
export function duplicate(line, event) {
  const obj = window.canvas.getActiveObject();
  const pointer = window.canvas.getPointer(event);
  let { x } = pointer;
  let { y } = pointer;
  if (obj) {
    obj.clone((newObj) => {
      window.canvas.discardActiveObject();
      line.set({ toNode: newObj });
      switch (line.toPort) {
        case 'mr':
          x -= newObj.width;
          y -= newObj.height / 2;
          break;
        case 'ml':
          y -= newObj.height / 2;
          break;
        case 'mb':
          x -= newObj.width / 2;
          y -= newObj.height;
          break;
        case 'mt':
          x -= newObj.width / 2;
          break;
        default:
          break;
      }
      newObj.set({
        left: x,
        top: y,
        evented: true,
      });
      if (newObj.type === ACTIVE_SELECTION) {
        newObj.forEachObject((o) => {
          getObjId(o);
          window.canvas.add(o);
        });
        newObj.setCoords();
      } else {
        getObjId(newObj);
        window.canvas.add(newObj);
      }
      line.set({ toId: newObj.id });
      window.canvas.setActiveObject(newObj);
      UpdateAllPathsAssociatedWithObj(newObj);
      eventBus.emit('reload-oldTree', newObj);

      window.canvas.requestRenderAll();
    }, propertiesToInclude);
  }
}
export function getAllDiagramPort(target) {
  const listPort = getPortFromDiagramObj(target);
  const listCircle = [];
  listPort.map((e) =>
    listCircle.push(
      new fabric.Circle({
        left: e.x - 3,
        top: e.y - 3,
        strokeWidth: 1,
        opacity: 0.5,
        radius: 3,
        isNotObj: true,
        fill: 'blue',
        stroke: 'blue',
      }),
    ),
  );
  return listCircle;
}
function drawLine(eventData, transform) {
  const pointer = window.canvas.getPointer(eventData);
  const { x, y } = pointer;
  const position = { x, y };
  const { target } = transform;
  const { canvas } = target;
  const fromPort = getTheNearestPort(position, target);
  control1 = { x: fromPort.x, y: fromPort.y };
  control2 = { x, y };
  let line = new fabric.Polyline([control1, control2], {
    name: FABRIC_CUSTOM_OBJECT.pathArrow,
    padding: 20,
    fill: '#A9A9A9',
    stroke: '#A9A9A9',
    strokeWidth: 1,
    selectable: false,
    hasControls: false,
    hasBorders: false,
    fromNode: target,
    fromPort: fromPort.fromPort,
    fromId: target.id,
    destination: { ...control2 },
    perPixelTargetFind: true,
    id: generateId(),
    objectCaching: false,
  });
  switch (line.fromPort) {
    case 'mt':
      line.set({ toPort: 'mb' });
      break;
    case 'mb':
      line.set({ toPort: 'mt' });
      break;
    case 'ml':
      line.set({ toPort: 'mr' });
      break;
    case 'mr':
      line.set({ toPort: 'ml' });
      break;
    default:
      break;
  }

  canvas.add(line);
  const listCircle = getAllDiagramPort(transform.target);
  canvas.add(...listCircle);
  function drawPath() {
    const newpoints = getPathFromTwoPoints(control1, control2, line.fromPort, line.toPort);
    if (line.name !== FABRIC_CUSTOM_OBJECT.line) addArrow(newpoints, line.strokeWidth);
    const index = getIndex(line);
    canvas.remove(line);
    const newline = new fabric.Polyline(newpoints, {
      padding: 20,
      name: line.name,
      fill: line.fill,
      stroke: line.stroke,
      strokeWidth: line.strokeWidth,
      toPort: line.toPort,
      fromPort: line.fromPort,
      toNode: line.toNode,
      fromNode: line.fromNode,
      toId: line.toId,
      fromId: line.fromId,
      hasControls: line.hasControls,
      hasBorders: line.hasBorders,
      lockMovementX: line.lockMovementX,
      lockMovementY: line.lockMovementY,
      perPixelTargetFind: true,
      destination: { x: control2.left, y: control2.top },
      id: line.id,
      objectCaching: false,
    });

    canvas.insertAt(newline, index);

    updateLabel(newline);
    line = newline;
  }
  function onMouseMoveDrawing(event) {
    const getPointer = canvas.getPointer(event);
    const posX = getPointer.x;
    const posY = getPointer.y;
    control2 = { x: posX, y: posY };
    autoFixLine(line);
    drawPath();
  }
  function onMouseUpDrawing(event) {
    canvas.remove(...listCircle);
    document.removeEventListener('mousemove', onMouseMoveDrawing);
    document.removeEventListener('mouseup', onMouseUpDrawing);
    if (!line.toNode) {
      duplicate(line, event);
    }
    const index = getIndex(line);
    canvas.remove(line);
    if (line.toNode) {
      updateLine(line);
      const points = getPath(line);
      const destination = { ...points[points.length - 1] };
      addArrow(points, line.strokeWidth);
      const polyline = new fabric.Polyline(points, {
        padding: 20,
        name: line.name,
        fill: line.fill,
        stroke: line.stroke,
        strokeWidth: line.strokeWidth,
        toPort: line.toPort,
        fromPort: line.fromPort,
        toNode: line.toNode,
        fromNode: line.fromNode,
        toId: line.toId,
        fromId: line.fromId,
        hasControls: false,
        hasBorders: false,
        lockMovementX: false,
        lockMovementY: false,
        perPixelTargetFind: true,
        destination,
        objectCaching: false,
      });
      if (line.id) polyline.set({ id: line.id });
      else polyline.set({ id: generateId() });
      canvas.insertAt(polyline, index);
      updateConnector(polyline);
    }
  }
  document.addEventListener('mousemove', onMouseMoveDrawing);
  document.addEventListener('mouseup', onMouseUpDrawing);
}

export function getPathStringFromPoints(points, shapeStyle, borderRadius = 5) {
  let path = '',
    lineDirection;
  switch (shapeStyle) {
    case LINE_SHAPE_TYPE[3].shapeType:
      path +=
        'M ' + points[0].x + ' ' + points[0].y + ' ' + points[points.length - 1].x + ' ' + points[points.length - 1].y;
      break;
    case LINE_SHAPE_TYPE[2].shapeType:
      for (let i = 0; i < points.length; i++) {
        if (i === 0) path += 'M ' + points[i].x + ' ' + points[i].y;
        if (points[i].corner) {
          switch (points[i].corner) {
            case 'tl': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? RIGHT : DOWN;
              let origin, destination, width, height;
              let fistCornerBeside, secondCornerBeside;
              for (let index = i - 1; index >= 0; index--) {
                if (points[index].corner || index === 0) {
                  fistCornerBeside = points[index];
                  break;
                }
              }
              for (let index = i + 1; index < points.length; index++) {
                if (points[index].corner || index === points.length - 1) {
                  secondCornerBeside = points[index];
                  break;
                }
              }
              if (fistCornerBeside.corner) {
                origin = {
                  x: lineDirection === RIGHT ? fistCornerBeside.x : (fistCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === RIGHT ? (fistCornerBeside.y + points[i].y) / 2 : fistCornerBeside.y,
                };
              } else {
                origin = fistCornerBeside;
              }
              if (secondCornerBeside.corner) {
                destination = {
                  x: lineDirection === DOWN ? secondCornerBeside.x : (secondCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === DOWN ? (secondCornerBeside.y + points[i].y) / 2 : secondCornerBeside.y,
                };
              } else {
                destination = secondCornerBeside;
              }
              if (lineDirection === RIGHT) {
                width = Math.abs(destination.x - points[i].x);
                height = Math.abs(origin.y - points[i].y);
              } else {
                height = Math.abs(destination.y - points[i].y);
                width = Math.abs(origin.x - points[i].x);
              }

              if (width !== 0 && height !== 0)
                path +=
                  ' A ' +
                  width +
                  ' ' +
                  height +
                  ` 0 0 ${lineDirection === DOWN ? '0' : '1'} ` +
                  destination.x +
                  ' ' +
                  destination.y;
              else path += ' L ' + destination.x + ' ' + destination.y;
              break;
            }
            case 'tr': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? LEFT : DOWN;
              let origin, destination, width, height;
              let fistCornerBeside, secondCornerBeside;
              for (let index = i - 1; index >= 0; index--) {
                if (points[index].corner || index === 0) {
                  fistCornerBeside = points[index];
                  break;
                }
              }
              for (let index = i + 1; index < points.length; index++) {
                if (points[index].corner || index === points.length - 1) {
                  secondCornerBeside = points[index];
                  break;
                }
              }
              if (fistCornerBeside.corner) {
                origin = {
                  x: lineDirection === LEFT ? fistCornerBeside.x : (fistCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === LEFT ? (fistCornerBeside.y + points[i].y) / 2 : fistCornerBeside.y,
                };
              } else {
                origin = fistCornerBeside;
              }
              if (secondCornerBeside.corner) {
                destination = {
                  x: lineDirection === DOWN ? secondCornerBeside.x : (secondCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === DOWN ? (secondCornerBeside.y + points[i].y) / 2 : secondCornerBeside.y,
                };
              } else {
                destination = secondCornerBeside;
              }
              if (lineDirection === LEFT) {
                width = Math.abs(destination.x - points[i].x);
                height = Math.abs(origin.y - points[i].y);
              } else {
                height = Math.abs(destination.y - points[i].y);
                width = Math.abs(origin.x - points[i].x);
              }

              if (width !== 0 && height !== 0)
                path +=
                  ' A ' +
                  width +
                  ' ' +
                  height +
                  ` 0 0 ${lineDirection === DOWN ? '1' : '0'} ` +
                  destination.x +
                  ' ' +
                  destination.y;
              else path += ' L ' + destination.x + ' ' + destination.y;
              break;
            }
            case 'bl': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? RIGHT : UP;
              let origin, destination, width, height;
              let fistCornerBeside, secondCornerBeside;
              for (let index = i - 1; index >= 0; index--) {
                if (points[index].corner || index === 0) {
                  fistCornerBeside = points[index];
                  break;
                }
              }
              for (let index = i + 1; index < points.length; index++) {
                if (points[index].corner || index === points.length - 1) {
                  secondCornerBeside = points[index];
                  break;
                }
              }
              if (fistCornerBeside.corner) {
                origin = {
                  x: lineDirection === RIGHT ? fistCornerBeside.x : (fistCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === RIGHT ? (fistCornerBeside.y + points[i].y) / 2 : fistCornerBeside.y,
                };
              } else {
                origin = fistCornerBeside;
              }
              if (secondCornerBeside.corner) {
                destination = {
                  x: lineDirection === UP ? secondCornerBeside.x : (secondCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === UP ? (secondCornerBeside.y + points[i].y) / 2 : secondCornerBeside.y,
                };
              } else {
                destination = secondCornerBeside;
              }
              if (lineDirection === RIGHT) {
                width = Math.abs(destination.x - points[i].x);
                height = Math.abs(origin.y - points[i].y);
              } else {
                height = Math.abs(destination.y - points[i].y);
                width = Math.abs(origin.x - points[i].x);
              }
              if (width !== 0 && height !== 0)
                path +=
                  ' A ' +
                  width +
                  ' ' +
                  height +
                  ` 0 0 ${lineDirection === UP ? '1' : '0'} ` +
                  destination.x +
                  ' ' +
                  destination.y;
              else path += ' L ' + destination.x + ' ' + destination.y;
              break;
            }
            case 'br': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? LEFT : UP;
              let origin, destination, width, height;
              let fistCornerBeside, secondCornerBeside;
              for (let index = i - 1; index >= 0; index--) {
                if (points[index].corner || index === 0) {
                  fistCornerBeside = points[index];
                  break;
                }
              }
              for (let index = i + 1; index < points.length; index++) {
                if (points[index].corner || index === points.length - 1) {
                  secondCornerBeside = points[index];
                  break;
                }
              }
              if (fistCornerBeside.corner) {
                origin = {
                  x: lineDirection === LEFT ? fistCornerBeside.x : (fistCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === LEFT ? (fistCornerBeside.y + points[i].y) / 2 : fistCornerBeside.y,
                };
              } else {
                origin = fistCornerBeside;
              }
              if (secondCornerBeside.corner) {
                destination = {
                  x: lineDirection === UP ? secondCornerBeside.x : (secondCornerBeside.x + points[i].x) / 2,
                  y: lineDirection === UP ? (secondCornerBeside.y + points[i].y) / 2 : secondCornerBeside.y,
                };
              } else {
                destination = secondCornerBeside;
              }
              if (lineDirection === LEFT) {
                width = Math.abs(destination.x - points[i].x);
                height = Math.abs(origin.y - points[i].y);
              } else {
                height = Math.abs(destination.y - points[i].y);
                width = Math.abs(origin.x - points[i].x);
              }
              if (width !== 0 && height !== 0)
                path +=
                  ' A ' +
                  width +
                  ' ' +
                  height +
                  ` 0 0 ${lineDirection === UP ? '0' : '1'} ` +
                  destination.x +
                  ' ' +
                  destination.y;
              else path += ' L ' + destination.x + ' ' + destination.y;
              break;
            }
          }
        } else path += ' L ' + points[i].x + ' ' + points[i].y;
      }
      break;
    default:
      for (let i = 0; i < points.length; i++) {
        if (i === 0) path += 'M ' + points[i].x + ' ' + points[i].y;
        else if (points[i].corner && shapeStyle === LINE_SHAPE_TYPE[1].shapeType) {
          switch (points[i].corner) {
            case 'tl': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? RIGHT : DOWN;
              let origin, destination;
              let fistCornerBeside = points[i - 1];
              let secondCornerBeside = points[i + 1];
              if (lineDirection === DOWN) {
                let mt = fistCornerBeside ? { x: (fistCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let ml = secondCornerBeside ? { x: points[i].x, y: (secondCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x + borderRadius, y: points[i].y };
                origin = origin.x > mt?.x ? { x: mt?.x, y: points[i].y } : origin;
                destination = { x: points[i].x, y: points[i].y + borderRadius };
                destination = destination.y > ml?.y ? { x: points[i].x, y: ml?.y } : destination;
              } else {
                let ml = fistCornerBeside ? { x: points[i].x, y: (fistCornerBeside.y + points[i].y) / 2 } : {};
                let mt = secondCornerBeside ? { x: (secondCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                origin = { x: points[i].x, y: points[i].y + borderRadius };
                origin = origin.y > ml?.y ? { x: points[i].x, y: ml?.y } : origin;
                destination = { x: points[i].x + borderRadius, y: points[i].y };
                destination = destination.x > mt?.x ? { x: mt?.x, y: points[i].y } : destination;
              }
              path +=
                ' L ' +
                origin.x +
                ' ' +
                origin.y +
                ' Q ' +
                points[i].x +
                ' ' +
                points[i].y +
                ', ' +
                destination.x +
                ' ' +
                destination.y;
              break;
            }
            case 'tr': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? LEFT : DOWN;
              let origin, destination;
              let fistCornerBeside = points[i - 1];
              let secondCornerBeside = points[i + 1];
              if (lineDirection === DOWN) {
                let mt = fistCornerBeside ? { x: (fistCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let mr = secondCornerBeside ? { x: points[i].x, y: (secondCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x - borderRadius, y: points[i].y };
                origin = origin.x < mt?.x ? { x: mt?.x, y: points[i].y } : origin;
                destination = { x: points[i].x, y: points[i].y + borderRadius };
                destination = destination.y > mr?.y ? { x: points[i].x, y: mr?.y } : destination;
              } else {
                let mr = fistCornerBeside ? { x: points[i].x, y: (fistCornerBeside.y + points[i].y) / 2 } : {};
                let mt = secondCornerBeside ? { x: (secondCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                origin = { x: points[i].x, y: points[i].y + borderRadius };
                origin = origin.y > mr?.y ? { x: points[i].x, y: mr?.y } : origin;
                destination = { x: points[i].x - borderRadius, y: points[i].y };
                destination = destination.x < mt?.x ? { x: mt?.x, y: points[i].y } : destination;
              }
              path +=
                ' L ' +
                origin.x +
                ' ' +
                origin.y +
                ' Q ' +
                points[i].x +
                ' ' +
                points[i].y +
                ', ' +
                destination.x +
                ' ' +
                destination.y;
              break;
            }
            case 'bl': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? RIGHT : UP;
              let origin, destination;
              let fistCornerBeside = points[i - 1];
              let secondCornerBeside = points[i + 1];
              if (lineDirection === UP) {
                let mb = fistCornerBeside ? { x: (fistCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let ml = secondCornerBeside ? { x: points[i].x, y: (secondCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x + borderRadius, y: points[i].y };
                origin = origin.x > mb?.x ? { x: mb?.x, y: points[i].y } : origin;
                destination = { x: points[i].x, y: points[i].y - borderRadius };
                destination = destination.y < ml?.y ? { x: points[i].x, y: ml?.y } : destination;
              } else {
                let mb = secondCornerBeside ? { x: (secondCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let ml = fistCornerBeside ? { x: points[i].x, y: (fistCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x, y: points[i].y - borderRadius };
                origin = origin.y < ml?.y ? { x: points[i].x, y: ml?.y } : origin;
                destination = { x: points[i].x + borderRadius, y: points[i].y };
                destination = destination.x > mb?.x ? { x: mb?.x, y: points[i].y } : destination;
              }
              path +=
                ' L ' +
                origin.x +
                ' ' +
                origin.y +
                ' Q ' +
                points[i].x +
                ' ' +
                points[i].y +
                ', ' +
                destination.x +
                ' ' +
                destination.y;
              break;
            }
            case 'br': {
              lineDirection = points[i - 1]?.x === points[i]?.x ? LEFT : UP;
              let origin, destination;
              let fistCornerBeside = points[i - 1];
              let secondCornerBeside = points[i + 1];
              if (lineDirection === UP) {
                let mb = fistCornerBeside ? { x: (fistCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let mr = secondCornerBeside ? { x: points[i].x, y: (secondCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x - borderRadius, y: points[i].y };
                origin = origin.x < mb?.x ? { x: mb?.x, y: points[i].y } : origin;
                destination = { x: points[i].x, y: points[i].y - borderRadius };
                destination = destination.y < mr?.y ? { x: points[i].x, y: mr?.y } : destination;
              } else {
                let mb = secondCornerBeside ? { x: (secondCornerBeside.x + points[i].x) / 2, y: points[i].y } : {};
                let mr = fistCornerBeside ? { x: points[i].x, y: (fistCornerBeside.y + points[i].y) / 2 } : {};
                origin = { x: points[i].x, y: points[i].y - borderRadius };
                origin = origin.y < mr?.y ? { x: points[i].x, y: mr?.y } : origin;
                destination = { x: points[i].x - borderRadius, y: points[i].y };
                destination = destination.x < mb?.x ? { x: mb?.x, y: points[i].y } : destination;
              }
              path +=
                ' L ' +
                origin.x +
                ' ' +
                origin.y +
                ' Q ' +
                points[i].x +
                ' ' +
                points[i].y +
                ', ' +
                destination.x +
                ' ' +
                destination.y;
              break;
            }
          }
        } else path += ' L ' + points[i].x + ' ' + points[i].y;
      }
  }
  return path;
}

// // data 4 ports

/* eslint-disable */
const svg1 =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMSwxNy41IDIzLDE3LjUgMTIsNi41ICIgZmlsbD0iIzE0NjRmNiIvPgo8L3N2Zz4=';
const svg2 =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iNi41LDEgNi41LDIzIDE3LjUsMTIgIiBmaWxsPSIjMTQ2NGY2Ii8+Cjwvc3ZnPg==';
const svg3 =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMSw2LjUgMjMsNi41IDEyLDE3LjUgIiBmaWxsPSIjMTQ2NGY2Ii8+Cjwvc3ZnPg==';
const svg4 =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMTcuNSwxIDE3LjUsMjMgNi41LDEyICIgZmlsbD0iIzE0NjRmNiIvPgo8L3N2Zz4=';

const svg1Hover =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMSwxNy41IDIzLDE3LjUgMTIsNi41ICIgZmlsbD0iIzE0NjRmNiIgc3R5bGU9ImZpbGwtb3BhY2l0eTogLjQ7Ii8+Cjwvc3ZnPg==';
const svg2Hover =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiAgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIiAgPgo8cG9seWdvbiBwb2ludHM9IjYuNSwxIDYuNSwyMyAxNy41LDEyICIgZmlsbD0iIzE0NjRmNiIgc3R5bGU9ImZpbGwtb3BhY2l0eTogLjQ7Ii8+Cjwvc3ZnPg==';
const svg3Hover =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMSw2LjUgMjMsNi41IDEyLDE3LjUgIiBmaWxsPSIjMTQ2NGY2IiBzdHlsZT0iZmlsbC1vcGFjaXR5OiAuNDsiLz4KPC9zdmc+';
const svg4Hover =
  'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xXzFfIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiICA+Cjxwb2x5Z29uIHBvaW50cz0iMTcuNSwxIDE3LjUsMjMgNi41LDEyICIgZmlsbD0iIzE0NjRmNiIgc3R5bGU9ImZpbGwtb3BhY2l0eTogLjQ7Ii8+Cjwvc3ZnPg==';

const img1 = document.createElement('img');
img1.src = svg1;
const img2 = document.createElement('img');
img2.src = svg2;
const img3 = document.createElement('img');
img3.src = svg3;
const img4 = document.createElement('img');
img4.src = svg4;
// render ports
function renderIcon1(ctx, left, top, styleOverride, fabricObject) {
  if (!fabricObject.isDiagram) {
    fabricObject.setControlsVisibility({ Port_1: false, Port_2: false, Port_3: false, Port_4: false });
    return;
  }
  if (state4Port.Port_1) img1.src = svg1;
  else img1.src = svg1Hover;
  const size = this.cornerSize;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img1, -size / 2, -size / 2, size, size);
  ctx.restore();
}
function renderIcon2(ctx, left, top, styleOverride, fabricObject) {
  if (state4Port.Port_2) img2.src = svg2;
  else img2.src = svg2Hover;
  const size = this.cornerSize;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img2, -size / 2, -size / 2, size, size);
  ctx.restore();
}
function renderIcon3(ctx, left, top, styleOverride, fabricObject) {
  if (state4Port.Port_3) img3.src = svg3;
  else img3.src = svg3Hover;
  const size = this.cornerSize;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img3, -size / 2, -size / 2, size, size);
  ctx.restore();
}
function renderIcon4(ctx, left, top, styleOverride, fabricObject) {
  if (state4Port.Port_4) img4.src = svg4;
  else img4.src = svg4Hover;
  const size = this.cornerSize;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img4, -size / 2, -size / 2, size, size);
  ctx.restore();
}
// create 4 ports
fabric.Object.prototype.controls.Port_1 = new fabric.Control({
  x: 0,
  y: -0.5,
  offsetY: -15,
  cursorStyle: 'pointer',
  mouseDownHandler: drawLine,
  render: renderIcon1,
  cornerSize: 24,
});
fabric.Object.prototype.controls.Port_2 = new fabric.Control({
  x: 0.5,
  y: 0,
  offsetX: 15,
  cursorStyle: 'pointer',
  mouseDownHandler: drawLine,
  render: renderIcon2,
  cornerSize: 24,
});
fabric.Object.prototype.controls.Port_3 = new fabric.Control({
  x: 0,
  y: 0.5,
  offsetY: 15,
  cursorStyle: 'pointer',
  mouseDownHandler: drawLine,
  render: renderIcon3,
  cornerSize: 24,
});
fabric.Object.prototype.controls.Port_4 = new fabric.Control({
  x: -0.5,
  y: 0,
  offsetX: -15,
  cursorStyle: 'pointer',
  mouseDownHandler: drawLine,
  render: renderIcon4,
  cornerSize: 24,
});
